export default __webpack_public_path__ + "static/media/hindi-flashcards.c83a7c3e.png";